<template>
  <div v-if="modal">
    <modal-bottom :opened="true" style="z-index: 99999">
      <div class="container mt-4">
        <div class="text-center">
          <h5 class="mb-3">Acesse todos os recursos</h5>
          <p class="mb-4">
            Para aproveitar todos os recursos, clique no botão abaixo e abra no navegador do seu dispositivo.
          </p>
        </div>
        <div>
          <button class="btn btn-primary btn-block rounded-sm p-2 mb-3" @click="abrirNavegador()">
            Abrir no navegador
          </button>
          <button type="button" class="btn btn-block rounded-sm p-3 mb-2" @click="fecharModal()">
            Continuar aqui
          </button>
        </div>
      </div>
    </modal-bottom>
  </div>
</template>

<script>
  import Loading from "./Loading";
  import ModalBottom from "./ModalBottom";

  export default {
    name: 'ModalInstagram',
    components: {ModalBottom, Loading },
    data() {
      return {
        modal: false
      }
    },

    methods: {
      abrirNavegador() {
        if (!this.isAndroid) return;

        this.modal = false;
        try {
          const url = window.location.href;
          window.location.href = `intent:${url}#Intent;end`;

        } catch (err) {
          console.log("Error opening in default browser:", err);
        }
      },

      fecharModal() {
        this.modal= false;
        sessionStorage.setItem('modalInsta', '1')
      }
    },

    mounted() {
      const modalInsta = sessionStorage.getItem('modalInsta') === '1';
      this.modal = !modalInsta && !!this.isInstagram && this.isAndroid && !['Links'].includes(this.$route.meta.page);
    }
  }
</script>

<style scoped>

</style>
